// The project's twins, on the map (V4DossierIsos).
export default {
  titre: 'Twins',
  sousTitre: 'The sub-twins of the brands in {nom}, drawn from their measured audiences: they go out every day and report back',
  ceDossier: 'this project',
  fermer: 'close',
  fermerTitre: 'Close',
  chargement: 'loading…',
  choisirDossier: 'Choose a project: its twins are those of all its brands.',
  carte: 'The project’s twins on the map',
  paysTerritoires: '{pays}: {liste}',
  lien: '{a} ↔ {b}: {sujets}',
  mode: {
    arene: 'Arena',
    grille: 'Grid',
  },
  phrase: {
    arene: 'Everything converges on the brands: their twins watch their channels and go and listen to what is said about them, wherever they hang out.',
    grille: 'No focus: the twins live their media day in the project’s territories. You see what exists around the brands.',
  },
  erreur: {
    flottes: 'Could not read the fleets',
    reglage: 'Could not save the settings',
  },
  quand: {
    aujourdhui: 'today around {heure}',
    demain: 'tomorrow around {heure}',
    jour: '{jour} around {heure}',
  },
  annonce: {
    activee: '{nom} fleet switched on: the first one leaves now, then every day on its own, at the time of Orion’s patrol. What it brings back also shows in Sentinel, Brands layer.',
    prochaine: 'Applied from the next fleet, {quand}. Today’s fleet finishes its day with the old settings.',
    eteinte: '{nom} fleet switched off: no new one will leave.',
    eteinteJour: '{nom} fleet switched off: no new one will leave. Today’s fleet finishes its day.',
    enregistre: 'Saved: nothing changes for today’s fleet.',
    nePartPas: '{nom} is not going out.',
    nePartPasCar: '{nom} is not going out: {raison}.',
  },
  etat: {
    eteinte: 'off',
    jamais: 'never switched on',
    enVol: 'in flight · {fait}/{total} sessions',
    prochaine: 'next fleet {quand}',
    active: 'on',
  },
  raison: {
    miniature_attrayante: 'the thumbnail',
    titre: 'the title',
    createur_connu: 'a known creator',
    sujet: 'the topic',
  },
  activation: {
    titre: 'daily fleets',
    fermerParametres: 'Close the settings',
    ouvrirParametres: 'Size and targeted territories',
    parametres: 'Settings',
    isosJour: '{n} twins/day',
    eteindre: 'Switch off: no further fleet will leave',
    sansPersonas: 'The brands’ personas come first: their twins are their sub-twins',
    sansCible: 'Choose at least one territory for a brand, in the settings',
    activer: 'Switch on: the first fleet leaves now, then every day',
    personasDabord: 'The twins are the brands’ sub-twins: their personas come first. An audit of each brand works them out.',
  },
  voient: {
    titre: 'what your twins see',
    jourObserve: 'day observed {jour}',
    septJours: '7 days',
    rienEncore: 'Nothing yet: the first fleet has not come back. A topic must be seen to show up here, and persist to rise.',
    aucuneFlotte: 'No active fleet. Switch on the Arena or the Grid: their twins will go out every day, and what they see will come back here, and in Sentinel (Brands layer).',
    monte: 'what is rising',
    sujet: '{sujet}: {territoire}, {mode} · fresh weight {poids} · seen {jours} day | {sujet}: {territoire}, {mode} · fresh weight {poids} · seen {jours} days',
    sujetMarque: '{sujet}: {territoire}, {mode}, {marque} · fresh weight {poids} · seen {jours} day | {sujet}: {territoire}, {mode}, {marque} · fresh weight {poids} · seen {jours} days',
    traverse: 'what is crossing your territories',
    prevus: 'planned, not out yet',
  },
  parametres: {
    titre: 'settings',
    sansPersonas: 'No personas yet: its twins are its sub-twins, so nobody goes out. An audit of the brand works them out.',
    parTerritoire: 'Twins per territory',
    propose: 'suggested: {n}',
    revenir: 'reset',
    cibles: 'targeted territories',
    aussiPorte: 'Also carried by {liste}: each one sends its twins there',
    aucunTerritoireMarque: 'No territory: they are detected by the brand’s audit.',
    cout: "≈ {'$'}{jour} per day · {'$'}{mois} per month",
    dossier: 'project',
    coutMesure: 'Cost measured on real outings.',
    coutEstime: 'Estimate, before the first measurement.',
    aucunTerritoire: 'No territory: they are detected by the audit of the project’s brands.',
    sansMarqueUn: '{liste}: open to the project, but no brand carries it, so no brand twin goes there.',
    sansMarquePlusieurs: '{liste}: open to the project, but no brand carries them, so no brand twin goes there.',
    enAttente: 'Today’s fleet left with the old settings: the new ones will apply to the next one, {quand}.',
    indiceAppliquer: 'Saves each brand’s size and territories',
    appliquer: 'Apply',
    prochaine: 'will apply to the next fleet if today’s has already left',
  },
  fiche: {
    portePar: 'carried by {liste}',
    isosLe: '· {n} twins on {jour}',
    sansSignal: '· {pct}% with no signal',
    monte: 'rising',
    apparait: 'appearing',
    tient: 'holding',
    createurs: 'creators',
    cliquent: 'they click for',
    ecarts: 'perceived vs expected',
    cible: 'Targeted: the first fleet has not come back yet.',
    aucun: 'No twins of this mode in this territory.',
  },
  sansLieu: 'not placed on the map: {liste}',
}
